import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  connect,
  disconnect,
  subscribeToNotifications,
  subscribeToStatus,
  HUB_STATUS,
} from "services/notificationHubService";
import { fetchNotifications, notificationReceived } from "slices/notificationsSlice";

export const useNotificationHub = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let hasConnected = false;

    dispatch(fetchNotifications());

    const unsubscribeNotifications = subscribeToNotifications((payload) => {
      if (payload?.id == null) {
        dispatch(fetchNotifications());
        return;
      }
      dispatch(notificationReceived(payload));
    });

    const unsubscribeStatus = subscribeToStatus((status) => {
      if (status !== HUB_STATUS.CONNECTED) return;
      if (hasConnected) dispatch(fetchNotifications());
      hasConnected = true;
    });

    connect();

    return () => {
      unsubscribeNotifications();
      unsubscribeStatus();
      disconnect();
    };
  }, [dispatch]);
};

export default useNotificationHub;
